export const GET_DATA = 'getDataCo';
export const LOADING = 'loadingCo';
export const ERROR = 'errorCo';
export const SELECTING = 'selectingCo'